module.exports = __webpack_public_path__ + "static/media/handshake.74f5d5eb.svg";